import React from "react";
import style from "./OneOffer.module.css";
import { icons } from "../../../../../stuffs/Icons";
import { searchIcon } from "../../../../../stuffs/SearchIcon";
import { voivodeships } from "../../../../../stuffs/Voivodeships";
import {
  MdDomain,
  MdLocalPhone,
  MdEmail,
  MdWeb,
  MdLocationOn,
} from "react-icons/md";

interface PropsOffer {
  _id?: string;
  name: string;
  shortName: string;
  website: string;
  email: string;
  phone: number | string;
  NIP: number | string;
  description: string;
  mainField: string;
  voivodeship: string;
  isHighlighted?: boolean;
  isRecommended?: boolean;
  isDetailsMode?: boolean;
}

const OneOffer: React.FC<PropsOffer> = ({
  name,
  shortName,
  website,
  email,
  phone,
  NIP,
  mainField,
  voivodeship,
  isHighlighted,
  isRecommended,
  isDetailsMode = false,
}) => {
  const icon = icons.find(
    (icon) => icon.routing === mainField
  );

  const voivodeshipTitle =
    voivodeships.find(
      (item) => item.value === voivodeship
    )?.title || voivodeship;

  const absolutPath = (): string => {
    const www = `${website}`;

    if (
      www.includes("https://") ||
      www.includes("http://")
    ) {
      return www;
    }

    return `https://${www}`;
  };

  return (
    <div
      className={`
        ${style.Offer}
        ${isHighlighted ? style.Highlighted : ""}
        ${isRecommended ? style.Recommended : ""}
        ${isDetailsMode ? style.OfferDetails : ""}
      `}
    >
      {isRecommended && (
        <div className={style.Ribbon}>
          POLECANA
        </div>
      )}

      <div className={style.LeftBox}>
        <div className={style.IconBox}>
          {icon === undefined
            ? searchIcon[0].svg
            : icon.svg}
        </div>
      </div>

      <div className={style.MainBox}>
        <div
          className={`${style.Name} ${
            isDetailsMode
              ? style.NameDetails
              : ""
          }`}
        >
          {shortName || name}
        </div>

        {!isDetailsMode && (
          <div className={style.BottomRow}>
            <div className={style.Meta}>
              <MdLocalPhone
                className={style.Icon}
              />
              <span>{phone}</span>
            </div>

            <div className={style.Meta}>
              <MdEmail
                className={style.Icon}
              />
              <span>{email}</span>
            </div>

            <a
              className={style.WebsiteLink}
              href={absolutPath()}
              target="_blank"
              rel="noreferrer"
              onClick={(e) =>
                e.stopPropagation()
              }
            >
              <MdWeb
                className={style.Icon}
              />
              {website}
            </a>
          </div>
        )}
      </div>

      {!isDetailsMode && (
        <div className={style.InfoBox}>
          <div className={style.NipBox}>
            <div className={style.NipIcon}>
              <MdDomain />
              <span>NIP</span>
            </div>

            <div className={style.NipValue}>
              {NIP}
            </div>
          </div>

          <div className={style.Voivodeship}>
            <MdLocationOn />
            <span>{voivodeshipTitle}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default OneOffer;